const paymentCalculator = {
  displayField: null,
  name: 'Payment Calculator',
  description: 'Calculate an estimated monthly payment.',
  fields: [],
  sys: {
    id: 'paymentCalculator',
    version: 4,
    updatedAt: '2023-03-16T18:32:56.020Z'
  }
};
export default paymentCalculator;